// imports
import JsonApiModel from '$dependencies/JsonApiModel';
import Config from '$root/Config';

// private static properties
const API_DICTIONARY = {
	uuid: 'id',
};

const FIELDS = {
	id: { type: String, default: '', identifier: true },
	name: { type: String, default: '' },
};

// class definition
export default class BinEmptyingFrequencyModel extends JsonApiModel {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.entityType = 'taxonomy_term--bin_emptying_frequencies';
		args.fields = FIELDS;
		args.config = {
			url: Config.getUrl('binEmptyingFrequencies'),
		};
		// json api settings
		args.jsonApi = Object.assign(args.jsonApi || {}, {
			dictionary: API_DICTIONARY,
		});

		// call super constructor
		super(args);
	}
}
